import {
  Sort_Field,
  Sort_Order,
  type EntityPagerFilter,
} from "@/graphql/generated-types";
import type PagerManager from "@/helpers/manager/PagerManager";
import type { WithId } from "@/interfaces";
import { toExternalDateRange, toLongDateRange } from "@/stories/utils/dates";
import type {
  DefaultFilterType,
  ListResourceType,
  PageableQuery,
} from "@/types";

export type ExternalEventFeatureState<T extends WithId> = {
  listResourceType: ListResourceType;
  pager: PagerManager<T>;
};

export const EXTERNAL_EVENT_FEATURE = {
  async fetchItems(
    state: ExternalEventFeatureState<WithId>,
    filter: DefaultFilterType,
    getInternalItems: PageableQuery<unknown, EntityPagerFilter>,
    getExternalItems: PageableQuery<unknown, EntityPagerFilter>,
  ) {
    if (filter === "show_external_content") {
      const { dateFrom, dateTo } = toExternalDateRange();
      state.listResourceType = "external";

      const params: EntityPagerFilter = {
        dateFrom,
        dateTo,
        sorting: {
          field: Sort_Field.StartDate,
          order: Sort_Order.Asc,
        },
      };
      return await state.pager.paginate(getExternalItems, params, state);
    }

    state.listResourceType = "internal";
    const { dateFrom, dateTo } = toLongDateRange(filter === "show_upcoming");

    const params: EntityPagerFilter = {
      dateFrom,
      dateTo,
      sorting: {
        field: Sort_Field.StartDate,
        order: filter === "show_upcoming" ? Sort_Order.Asc : Sort_Order.Desc,
      },
    };
    await state.pager.paginate(getInternalItems, params, state);
  },
};
